import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import './Contact.css';

export const Contact = () => {
    const [buttonText, setButtonText] = useState('Send');
    const [status, setStatus] = useState({});
    const [showMessage, setShowMessage] = useState(false);
    const [userData, setUserData]= useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
    });
    let name, value;
    const postUserData=(event) => {
        name=event.target.name;
        value=event.target.value;

        setUserData({ ...userData, [name]: value});
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setButtonText("Sending...");
        const {firstName, lastName, email, phone, message} = userData;
        if(firstName && lastName && email && phone && message){
            try{
                const res = await fetch('https://piyushninaweportfolio-default-rtdb.firebaseio.com/userDataRecords.json',
                    {
                        method:"POST",
                        headers:{
                            "Content-Type": "application/json"
                        },
                        body:JSON.stringify({
                            firstName, 
                            lastName,
                            email, 
                            phone, 
                            message,
                        }),
                    }
                );
            
                setButtonText("Send");
                // let result = await res.json();
                setUserData({
                            firstName: '',
                            lastName: '',
                            email: '',
                            phone: '',
                            message: '',
                        })
                setStatus({ succes: true, message: 'Message sent successfully'});
  
            }catch (error){
                setButtonText("Send");
                setStatus({ success: false, message: 'Something went wrong, please try again later.' });
            }finally {
                setShowMessage(true);
                setTimeout(() => {
                    setShowMessage(false);
                }, 5000);
            }
        }else{
          setButtonText("Send");
          setStatus({ success: false, message: 'Please enter your information...' });
          setShowMessage(true);
          setTimeout(() => {
              setShowMessage(false);
          }, 5000);
      }
    };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Get In Touch</h2>
                <form onSubmit={handleSubmit} method="POST">
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={userData.firstName} name="firstName" placeholder="First Name" onChange={postUserData} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={userData.lastName} name="lastName" placeholder="Last Name" onChange={postUserData}/>
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" value={userData.email} name="email" placeholder="Email Address" onChange={postUserData} />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" value={userData.phone} name="phone" placeholder="Phone No." onChange={postUserData}/>
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea rows="6" value={userData.message} name="message" placeholder="Message" onChange={postUserData}></textarea>
                      <button type="submit"><span>{buttonText}</span></button>
                    </Col>
                  </Row>
                </form>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      {status.message && (
        <div className={`message-box ${showMessage ? 'show' : ''} ${status.success === false ? 'danger' : 'success'}`}>
          {status.message}
        </div>
      )}
    </section>
  );
}

